import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { MenuMockup, PosterMockup, FlyerMockup } from "@/components/Mockups";
import { useAnchorNav } from "@/lib/nav";

const Intro = () => {
  const go = useAnchorNav();
  return (
    <section id="intro" className="bg-navy py-20 sm:py-28">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <Reveal>
          <Eyebrow>Välkommen till Tillvia</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Din digitala närvaro börjar här.
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-cream/70 sm:text-lg">
            Tillvia hjälper företag att skapa en starkare och mer professionell närvaro online. Från hemsidor och
            grafisk design till sociala medier, digital annonsering och Google Företagsprofil – vi samlar flera
            digitala lösningar på ett ställe.
          </p>
          <a
            href="#om-oss"
            data-testid="intro-about-link"
            onClick={(e) => go(e, "om-oss")}
            className="mt-7 inline-flex items-center gap-2 font-display text-sm font-bold text-orange2 transition-colors hover:text-cream"
          >
            Läs mer om oss <ArrowRight size={16} aria-hidden="true" />
          </a>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="rounded-3xl bg-navy2 p-6 sm:p-9">
            <div className="grid grid-cols-2 gap-4 sm:gap-5">
              <MenuMockup className="-rotate-2" />
              <PosterMockup className="translate-y-4 rotate-2" />
              <FlyerMockup className="col-span-2 -rotate-1" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Intro;
